// ============================
// List Expiry Returns
// ============================
export const FETCH_EXPIRYRETURNDETAILS_INIT_ACTION =
  "FETCH_EXPIRYRETURNDETAILS_INIT_ACTION";

export const FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION =
  FETCH_EXPIRYRETURNDETAILS_INIT_ACTION + "_SUCCESS";

export const FETCH_EXPIRYRETURNDETAILS_FAIL_ACTION =
  FETCH_EXPIRYRETURNDETAILS_INIT_ACTION + "_ERROR";


// ============================
// View Expiry Return Items
// ============================
export const FETCH_EXPIRYRETURNVIEW_INIT_ACTION =
  "FETCH_EXPIRYRETURNVIEW_INIT_ACTION";

export const FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION =
  FETCH_EXPIRYRETURNVIEW_INIT_ACTION + "_SUCCESS";

export const FETCH_EXPIRYRETURNVIEW_FAIL_ACTION =
  FETCH_EXPIRYRETURNVIEW_INIT_ACTION + "_ERROR";


// ============================
// PDF
// ============================
export const PDF_EXPIRY_RETURN_REPORT_INIT_ACTION =
  "PDF_EXPIRY_RETURN_REPORT_INIT_ACTION";

export const PDF_EXPIRY_RETURN_REPORT_SUCCESS_ACTION =
  PDF_EXPIRY_RETURN_REPORT_INIT_ACTION + "_SUCCESS";

export const PDF_EXPIRY_RETURN_REPORT_FAIL_ACTION =
  PDF_EXPIRY_RETURN_REPORT_INIT_ACTION + "_ERROR";


// ============================
// Accept/Reject Actions
// ============================
export const FETCH_EXPIRY_RETUNREJECTED_INIT_ACTION =
  "FETCH_EXPIRY_RETUNREJECTED_INIT_ACTION";
export const FETCH_EXPIRY_RETUNACCEPTED_INIT_ACTION =
  "FETCH_EXPIRY_RETUNACCEPTED_INIT_ACTION";

export const FETCH_EXPIRY_ORDERDETAIL_ACCEPT_INIT =
  "FETCH_EXPIRY_ORDERDETAIL_ACCEPT_INIT";
export const FETCH_EXPIRY_ORDERDETAIL_REJECT_INIT =
  "FETCH_EXPIRY_ORDERDETAIL_REJECT_INIT";

export const UPDATE_EXPIRY_APPROVED_QTY_INIT = "UPDATE_EXPIRY_APPROVED_QTY_INIT";
export const UPDATE_EXPIRY_APPROVED_QTY_SUCCESS =
  "UPDATE_EXPIRY_APPROVED_QTY_SUCCESS";
export const UPDATE_EXPIRY_APPROVED_QTY_FAIL =
  "UPDATE_EXPIRY_APPROVED_QTY_FAIL";

export const UPDATE_EXPIRY_PURCHASEORDER_TOTALS_INIT =
  "UPDATE_EXPIRY_PURCHASEORDER_TOTALS_INIT";
export const UPDATE_EXPIRY_PURCHASEORDER_TOTALS_SUCCESS =
  "UPDATE_EXPIRY_PURCHASEORDER_TOTALS_SUCCESS";
export const UPDATE_EXPIRY_PURCHASEORDER_TOTALS_FAIL =
  "UPDATE_EXPIRY_PURCHASEORDER_TOTALS_FAIL";


// ============================
// Action Creators
// ============================
export function fetchExpiryReturns(value) {
  return {
    type: FETCH_EXPIRYRETURNDETAILS_INIT_ACTION,
    value,
  };
}

export function pageSelected(value) {
  return {
    type: FETCH_EXPIRYRETURNDETAILS_INIT_ACTION,
    value,
  };
}

export function ExpiryReturnview(value) {
  return {
    type: FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
    value,
  };
}

export function itempageSelected(value) {
  return {
    type: FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
    value,
  };
}

export function pdfExpiryReturnFullData(value) {
  return {
    type: PDF_EXPIRY_RETURN_REPORT_INIT_ACTION,
    value,
  };
}

export function returnaccept(value) {
  return {
    type: FETCH_EXPIRY_RETUNACCEPTED_INIT_ACTION,
    value,
  };
}

export function returnrejected(value) {
  return {
    type: FETCH_EXPIRY_RETUNREJECTED_INIT_ACTION,
    value,
  };
}

export function returnacceptOne(value) {
  return {
    type: FETCH_EXPIRY_ORDERDETAIL_ACCEPT_INIT,
    value,
  };
}

export function returnrejectedOne(value) {
  return {
    type: FETCH_EXPIRY_ORDERDETAIL_REJECT_INIT,
    value,
  };
}

export function updatePurchaseOrderTotals(value) {
  return {
    type: UPDATE_EXPIRY_PURCHASEORDER_TOTALS_INIT,
    value,
  };
}
